var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLCheckMIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_1878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3828 4.11719C17.8711 4.60547 17.8711 5.39844 17.3828 5.88672L7.38281 15.8867C6.89453 16.375 6.10156 16.375 5.61328 15.8867L0.613281 10.8867C0.125 10.3984 0.125 9.60547 0.613281 9.11719C1.10156 8.62891 1.89453 8.62891 2.38281 9.11719L6.5 13.2305L15.6172 4.11719C16.1055 3.62891 16.8984 3.62891 17.3867 4.11719H17.3828Z",
    fill: "#059669"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_1878"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.25 0H17.75V20H0.25V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLCheckMIcon);
export default __webpack_public_path__ + "static/media/l_check_m_icon.60d04f029b898754afc8a3521e3d7631.svg";
export { ForwardRef as ReactComponent };